<template>
<div>
  <svg id="form-background" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1921 522.07"><defs><linearGradient id="linear-gradient" x1="960" y1="148.67" x2="960" y2="-68.02" gradientTransform="translate(0 133.72)" gradientUnits="userSpaceOnUse"><stop offset="0.13" stop-color="#fff"/><stop offset="0.16" stop-color="#f9f9f9"/><stop offset="0.2" stop-color="#e9e8e9"/><stop offset="0.25" stop-color="#cecccf"/><stop offset="0.3" stop-color="#a8a5aa"/><stop offset="0.35" stop-color="#79737b"/><stop offset="0.4" stop-color="#473f4a"/></linearGradient><linearGradient id="GradientFill_8" x1="500.8" y1="130.71" x2="1427.56" y2="130.71" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2dbde9"/><stop offset="1" stop-color="#8e8dc4"/></linearGradient><radialGradient id="radial-gradient" cx="960" cy="36.9" r="679.32" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="0.6" stop-color="#eee"/><stop offset="0.97" stop-color="#e6e6e6"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient><radialGradient id="radial-gradient-2" cx="960" cy="36.45" r="679.71" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient><linearGradient id="linear-gradient-2" x1="959.9" y1="58.2" x2="959.9" y2="-34.99" gradientUnits="userSpaceOnUse"><stop offset="0.14" stop-color="#fff"/><stop offset="0.32" stop-color="#dbdadc"/><stop offset="0.71" stop-color="#827c84"/><stop offset="0.96" stop-color="#473f4a"/></linearGradient></defs><g style="isolation:isolate"><g id="Top"><rect x="0.5" y="208.79" width="1920" height="313.28" style="fill:#505050"/><rect x="0.5" y="230.09" width="1920" height="245.72" style="fill:#505050"/><rect y="155.02" width="1920" height="112" transform="translate(1920.5 630.83) rotate(180)" style="mix-blend-mode:multiply;fill:url(#linear-gradient)"/><path d="M1427.56,8.08c-155,.46-310.06.92-444.63-.16S734.26,4.22,657.31,6,540.58,14.12,500.8,20.38l88,217.81L1329.06,256ZM615.67,168.18c-15-24.78-37.88-70.75-60.78-116.71L657.4,46.72c49.56-2.3,122.2-5.65,196.39-7.33s149.92-1.69,234.49,1.6,178,9.91,271.38,16.51c-17.4,43.61-34.79,87.21-49.06,112.14s-25.43,31.17-135.88,33.14-320.2-.36-428.6-3.3S630.66,193,615.67,168.18Z" transform="translate(0.5 208.79)" style="fill-rule:evenodd;opacity:0.59;fill:url(#GradientFill_8)"/><path d="M1297.62,225.22H627.32c-29.94,0-45.82-44.08-54.45-64.89L508,4H468.53l94.92,209.1c1.46,3.55,2.91,7.11,2.35,11.53s-3.13,9.72-7.67,11.73-11,.71-15.39-1.9-6.6-6.55-8.84-10.49L432.71,4H389.37L514.58,266.55c9.92,20.8,28.17,39.5,62.6,39.5h770.59c34.43,0,52.68-18.7,62.6-39.5L1535.57,4h-41.5L1392.88,224c-2.24,3.94-4.47,7.87-8.84,10.49s-10.86,3.9-15.39,1.9-7.11-7.3-7.67-11.73.9-8,2.35-11.53L1458.25,4h-41.32l-64.85,156.34C1343.45,181.13,1327.57,225.22,1297.62,225.22Z" transform="translate(0.5 208.79)" style="fill:#f1f1f1;fill-rule:evenodd"/><path d="M1763.67,0H156.54l13.12,18.07c4.77,6.58-3.64,13.66-18.7,15.75L63.68,45.91C48.62,48,32.39,44.32,27.62,37.75L0,0V73.81c153.48-35.3,525.63-60.2,960.1-60.2s806.42,24.9,959.9,60.2V0l-27.41,37.75c-4.78,6.57-21,10.25-36.07,8.16l-87.28-12.09c-15.06-2.09-23.47-9.17-18.69-15.75Z" transform="translate(0.5 208.79)" style="stroke-miterlimit:10;stroke-width:1.0024756438763px;fill-rule:evenodd;fill:url(#radial-gradient);stroke:url(#radial-gradient-2)"/><path d="M807.77,10.9c-22.78,0-41.4-2.82-41.4-6.27V0h392.21V4.63c0,3.45-18.63,6.27-41.4,6.27Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;fill-rule:evenodd"/><path d="M1272.34,245c-8.22,0-17.12-.1-26.36-.2l-10.53-.12c-11.66-.12-23.25-.17-32.44-.22l-11-.06c-9.75-.06-12.69-.08-14.3-3.32-1.11-2.26-1.2-5.7-1.2-9.63v-6.19h4.23v6.19c0,2.32,0,6.2.76,7.75.41.83,3.07.92,10.54,1l11,.06c9.2.05,20.79.1,32.46.22,3.52,0,7,.08,10.54.12,13.7.15,26.64.3,37.72.12,14.43-.23,24.49-1,33.26-4.42,8-3.1,15.44-8,31.66-39.71,15.69-30.66,39.69-86.59,62.91-140.67l3.89,1.67c-23.25,54.15-47.28,110.14-63,140.93-15.42,30.15-23.52,37.71-33.91,41.72-9.35,3.62-19.81,4.47-34.71,4.71C1280.18,244.94,1276.34,245,1272.34,245Z" transform="translate(0.5 208.79)" style="fill:#b2b2b2"/><path d="M59.66,51.85h-.59a74,74,0,0,1-8.63-.59,61.18,61.18,0,0,1-7.75-1.49,45.36,45.36,0,0,1-5.6-1.87,19.11,19.11,0,0,1-3.51-1.85,19.54,19.54,0,0,1-4-3.81c-2.15-2.52-5.06-6.46-9.43-12.77C15.21,22.35,7.08,11.44,0,.89V0H159.78l.38.46c4.59,5.5,9.33,11.18,12.36,14.89s4.35,5.47,5.21,6.74a10.23,10.23,0,0,1,1.8,3.7,6.32,6.32,0,0,1-.38,3.63,9.06,9.06,0,0,1-2.34,3.14,17.93,17.93,0,0,1-3.75,2.56,34.4,34.4,0,0,1-4.82,2.05c-1.83.63-3.56,1.09-17.87,3.13-10.43,1.5-29.51,4.11-56.68,7.77-15.58,2.1-21,2.81-25,3.23A81.9,81.9,0,0,1,59.66,51.85ZM0,1.39C6.91,11.68,14.13,22.21,18.93,29.13c4.36,6.3,7.25,10.22,9.38,12.72A17.81,17.81,0,0,0,32,45.4a15.73,15.73,0,0,0,3,1.59,39.87,39.87,0,0,0,5.07,1.7,56,56,0,0,0,7,1.35,64.54,64.54,0,0,0,7.81.53,72,72,0,0,0,8.86-.51c3.94-.41,9.29-1.12,24.83-3.21,27.22-3.67,46.32-6.29,56.76-7.78,13.53-1.93,15.42-2.39,16.93-2.91a30.91,30.91,0,0,0,4.35-1.85A16,16,0,0,0,170,32a8,8,0,0,0,2.08-2.79,5.77,5.77,0,0,0,.34-3.27,9.58,9.58,0,0,0-1.68-3.43c-.85-1.26-2.06-2.87-5.17-6.68-2.95-3.62-7.53-9.1-12-14.47Z" transform="translate(0.5 208.79)" style="fill:#b2b2b2"/><path d="M1860.62,51.72a83.66,83.66,0,0,1-9-.54c-4-.43-9.37-1.14-24.9-3.23-27.1-3.65-46.12-6.26-56.55-7.75-14.27-2-16-2.49-17.82-3.12a34.26,34.26,0,0,1-4.81-2,17.46,17.46,0,0,1-3.74-2.55,9,9,0,0,1-2.34-3.14,6.36,6.36,0,0,1-.38-3.62,10.58,10.58,0,0,1,1.8-3.68c.89-1.3,2.06-2.88,5.2-6.72s8-9.65,12.33-14.86l.38-.46H1920V.89c-7.07,10.53-15,21.42-20,28.51-4.36,6.29-7.26,10.21-9.41,12.73a19.14,19.14,0,0,1-4,3.8,18.31,18.31,0,0,1-3.49,1.85,45.77,45.77,0,0,1-5.59,1.86,61.18,61.18,0,0,1-7.73,1.5,75.73,75.73,0,0,1-8.61.58ZM1763,1.39c-4.25,5.09-9,10.76-11.94,14.39-3.1,3.8-4.3,5.41-5.15,6.65a9.67,9.67,0,0,0-1.68,3.41,5.73,5.73,0,0,0,.35,3.26,7.87,7.87,0,0,0,2.07,2.78,16.18,16.18,0,0,0,3.32,2.27,31.84,31.84,0,0,0,4.33,1.84c1.5.52,3.39,1,16.85,2.9,10.4,1.48,29.41,4.09,56.49,7.74,16.35,2.2,21,2.8,24.71,3.2a73,73,0,0,0,8.82.5,66.14,66.14,0,0,0,7.78-.52,55.33,55.33,0,0,0,7-1.35,39.84,39.84,0,0,0,5-1.69,15.37,15.37,0,0,0,3-1.59,17.31,17.31,0,0,0,3.71-3.53c2.12-2.49,5-6.39,9.34-12.66,4.77-6.88,11.8-17.36,18.68-27.6Z" transform="translate(0.5 208.79)" style="fill:#b2b2b2"/><path d="M196.29,0l25.46,34.63c94.19-8.39,188.38-16.78,272.44-21s158-4.29,231.92-4.36L727.61,0Z" transform="translate(0.5 208.79)" style="fill:#9a83df;fill-rule:evenodd;opacity:0.16"/><path d="M1738.74,0l-25.46,34.63c-94.19-8.39-188.37-16.78-272.43-21s-158-4.29-231.92-4.36L1207.43,0Z" transform="translate(0.5 208.79)" style="fill:#9a83df;fill-rule:evenodd;opacity:0.16"/><polygon points="249.59 232.85 229.75 208.79 214.63 208.79 236.87 235.75 249.59 232.85" style="fill:#00022b;fill-rule:evenodd"/><polygon points="243.29 208.79 263.74 233.58 274.92 231.03 276.46 230.68 265.44 217.33 258.41 208.79 243.29 208.79" style="fill:#00022b;fill-rule:evenodd"/><polygon points="274.09 208.79 292.62 231.25 305.34 228.34 289.21 208.79 274.09 208.79" style="fill:#00022b;fill-rule:evenodd"/><polygon points="302.03 208.79 318.81 229.13 331.53 226.23 317.15 208.79 302.03 208.79" style="fill:#00022b;fill-rule:evenodd"/><polygon points="1684.96 232.85 1704.81 208.79 1719.93 208.79 1697.69 235.75 1684.96 232.85" style="fill:#00022b;fill-rule:evenodd"/><polygon points="1691.27 208.79 1670.82 233.58 1659.64 231.03 1658.1 230.68 1669.11 217.33 1676.15 208.79 1691.27 208.79" style="fill:#00022b;fill-rule:evenodd"/><polygon points="1660.47 208.79 1641.94 231.25 1629.22 228.34 1645.35 208.79 1660.47 208.79" style="fill:#00022b;fill-rule:evenodd"/><polygon points="1632.53 208.79 1615.75 229.13 1603.03 226.23 1617.41 208.79 1632.53 208.79" style="fill:#00022b;fill-rule:evenodd"/><path d="M0,48.17c88.72-11,177.65-22,268.45-30S452.14,5.08,579.07,2.54,867,0,1019,0s295.06,0,428.72,4.33,257.93,13,335.08,20.36S1890,38.15,1920,44.25V0L0,.7C-.71,16.52.71,32.35,0,48.17Z" transform="translate(0.5 208.79)" style="mix-blend-mode:multiply;fill:url(#linear-gradient-2)"/><path d="M471.74,67.21c23,50.59,46,101.19,59,127.75s16.19,29.11,18.88,30,4.93.15,5.15-2.69-1.57-7.76-13.73-34.24-34.71-74.51-57.25-122.54Z" transform="translate(0.5 208.79)" style="fill:#19c2ef;fill-rule:evenodd;opacity:0.30000000000000004"/><path d="M1454,67.82c-23,50.59-46,101.18-59,127.75s-16.2,29.1-18.88,30-4.93.15-5.15-2.69,1.57-7.76,13.73-34.24,34.71-74.51,57.25-122.55Z" transform="translate(0.5 208.79)" style="fill:#d33702;fill-rule:evenodd;opacity:0.30000000000000004"/><rect x="0.5" y="469.11" width="1920" height="31.32" style="fill:#f1f1f1"/><path d="M666.09,90.52h12.3l10,16.25,10-16.25h12.3v42H699.15V108.39l-10.74,16.44h-.24l-10.68-16.32v24h-11.4Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M718.41,90.52h11.7v42h-11.7Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M734.61,126.27l6.48-7.74a21.63,21.63,0,0,0,13.62,5c3.12,0,4.8-1.08,4.8-2.88v-.12c0-1.74-1.38-2.7-7.08-4-8.94-2-15.84-4.56-15.84-13.2v-.12c0-7.8,6.18-13.44,16.26-13.44,7.14,0,12.72,1.92,17.28,5.58l-5.82,8.22a21.06,21.06,0,0,0-11.76-4.14c-2.82,0-4.2,1.2-4.2,2.7v.12c0,1.92,1.44,2.76,7.26,4.08,9.66,2.1,15.66,5.22,15.66,13.08v.12c0,8.58-6.78,13.68-17,13.68C746.85,133.23,739.77,130.89,734.61,126.27Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M773.13,126.27l6.48-7.74a21.63,21.63,0,0,0,13.62,5c3.12,0,4.8-1.08,4.8-2.88v-.12c0-1.74-1.38-2.7-7.08-4-8.94-2-15.84-4.56-15.84-13.2v-.12c0-7.8,6.18-13.44,16.26-13.44,7.14,0,12.72,1.92,17.28,5.58l-5.82,8.22a21.06,21.06,0,0,0-11.76-4.14c-2.82,0-4.2,1.2-4.2,2.7v.12c0,1.92,1.44,2.76,7.26,4.08,9.66,2.1,15.66,5.22,15.66,13.08v.12c0,8.58-6.78,13.68-17,13.68C785.37,133.23,778.29,130.89,773.13,126.27Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M815.67,90.52h11.7v42h-11.7Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M833.61,111.63v-.12c0-12.06,9.72-21.84,22.68-21.84s22.56,9.66,22.56,21.72v.12c0,12.06-9.72,21.84-22.68,21.84S833.61,123.69,833.61,111.63Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S867,117.69,867,111.63Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M884.91,90.52h10.86l17.28,22.19V90.52h11.52v42h-10.2l-17.94-23v23H884.91Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M947.19,111.63v-.12c0-12.24,9.42-21.84,22.14-21.84,8.58,0,14.1,3.6,17.82,8.76l-8.76,6.78c-2.4-3-5.16-4.92-9.18-4.92-5.88,0-10,5-10,11.1v.12c0,6.3,4.14,11.22,10,11.22,4.38,0,7-2,9.48-5.1l8.76,6.24c-4,5.46-9.3,9.48-18.6,9.48A21.33,21.33,0,0,1,947.19,111.63Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M989.79,111.63v-.12c0-12.06,9.72-21.84,22.68-21.84S1035,99.33,1035,111.39v.12c0,12.06-9.72,21.84-22.68,21.84S989.79,123.69,989.79,111.63Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S1023.15,117.69,1023.15,111.63Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M1041.09,90.52H1052l17.28,22.19V90.52h11.52v42h-10.2l-17.94-23v23h-11.52Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M1098.45,100.71h-12.6V90.52h36.84v10.19h-12.6v31.8h-11.64Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M1127.79,90.52h19.86c6.42,0,10.86,1.67,13.68,4.55,2.46,2.4,3.72,5.64,3.72,9.78V105c0,6.42-3.42,10.68-8.64,12.9l10,14.64H1153l-8.46-12.72h-5.1v12.72h-11.64Zm19.32,20.15c4,0,6.24-1.92,6.24-5v-.12c0-3.3-2.4-5-6.3-5h-7.62v10.08Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M1169.49,111.63v-.12c0-12.06,9.72-21.84,22.68-21.84s22.55,9.66,22.55,21.72v.12c0,12.06-9.71,21.84-22.67,21.84S1169.49,123.69,1169.49,111.63Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S1202.85,117.69,1202.85,111.63Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M1220.79,90.52h11.64v31.79h20.33v10.2h-32Z" transform="translate(0.5 208.79)" style="fill:#1a1a1a;stroke:#1a1a1a;stroke-miterlimit:10;stroke-width:0.25px"/><path d="M667.89,88.71h12.3l10,16.26,10-16.26h12.3v42H701V106.59L690.21,123H690l-10.68-16.32v24h-11.4Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M720.21,88.71h11.7v42h-11.7Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M736.41,124.47l6.48-7.74a21.63,21.63,0,0,0,13.62,5c3.12,0,4.8-1.08,4.8-2.88v-.12c0-1.74-1.38-2.7-7.08-4-8.94-2-15.84-4.56-15.84-13.2v-.12c0-7.8,6.18-13.44,16.26-13.44,7.14,0,12.72,1.92,17.28,5.58l-5.82,8.22a21.06,21.06,0,0,0-11.76-4.14c-2.82,0-4.2,1.2-4.2,2.7v.12c0,1.92,1.44,2.76,7.26,4.08,9.66,2.1,15.66,5.22,15.66,13.08v.12c0,8.58-6.78,13.68-17,13.68C748.65,131.43,741.57,129.09,736.41,124.47Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M774.93,124.47l6.48-7.74a21.63,21.63,0,0,0,13.62,5c3.12,0,4.8-1.08,4.8-2.88v-.12c0-1.74-1.38-2.7-7.08-4-8.94-2-15.84-4.56-15.84-13.2v-.12c0-7.8,6.18-13.44,16.26-13.44,7.14,0,12.72,1.92,17.28,5.58l-5.82,8.22a21.06,21.06,0,0,0-11.76-4.14c-2.82,0-4.2,1.2-4.2,2.7v.12c0,1.92,1.44,2.76,7.26,4.08,9.66,2.1,15.66,5.22,15.66,13.08v.12c0,8.58-6.78,13.68-17,13.68C787.17,131.43,780.09,129.09,774.93,124.47Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M817.47,88.71h11.7v42h-11.7Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M835.41,109.83v-.12c0-12.06,9.72-21.84,22.68-21.84s22.56,9.66,22.56,21.72v.12c0,12.06-9.72,21.84-22.68,21.84S835.41,121.89,835.41,109.83Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S868.77,115.89,868.77,109.83Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M886.71,88.71h10.86l17.28,22.2V88.71h11.52v42h-10.2l-17.94-23v23H886.71Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M949,109.83v-.12c0-12.24,9.42-21.84,22.14-21.84,8.58,0,14.1,3.6,17.82,8.76l-8.76,6.78c-2.4-3-5.16-4.92-9.18-4.92-5.88,0-10,5-10,11.1v.12c0,6.3,4.14,11.22,10,11.22,4.38,0,7-2,9.48-5.1l8.76,6.24c-4,5.46-9.3,9.48-18.6,9.48A21.33,21.33,0,0,1,949,109.83Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M991.59,109.83v-.12c0-12.06,9.72-21.84,22.68-21.84s22.56,9.66,22.56,21.72v.12c0,12.06-9.72,21.84-22.68,21.84S991.59,121.89,991.59,109.83Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S1025,115.89,1025,109.83Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1042.89,88.71h10.86l17.28,22.2V88.71h11.52v42h-10.2l-17.94-23v23h-11.52Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1100.25,98.91h-12.6V88.71h36.84v10.2h-12.6v31.8h-11.64Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1129.59,88.71h19.86c6.42,0,10.86,1.68,13.68,4.56,2.46,2.4,3.72,5.64,3.72,9.78v.12c0,6.42-3.42,10.68-8.64,12.9l10,14.64h-13.44L1146.33,118h-5.1v12.72h-11.64Zm19.32,20.16c4,0,6.24-1.92,6.24-5v-.12c0-3.3-2.4-5-6.3-5h-7.62v10.08Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1171.29,109.83v-.12c0-12.06,9.72-21.84,22.68-21.84s22.55,9.66,22.55,21.72v.12c0,12.06-9.71,21.84-22.67,21.84S1171.29,121.89,1171.29,109.83Zm33.36,0v-.12c0-6.06-4.38-11.34-10.8-11.34s-10.62,5.16-10.62,11.22v.12c0,6.06,4.38,11.34,10.74,11.34S1204.65,115.89,1204.65,109.83Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1222.59,88.71h11.64v31.8h20.33v10.2h-32Z" transform="translate(0.5 208.79)" style="fill:#fff"/><path d="M1511,195h7.48l11.92,28.2h-8.32l-2-5h-10.8l-2,5h-8.15Zm6.8,17.16-3.12-8-3.16,8Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1530.37,209.27v-.08a14.38,14.38,0,0,1,14.76-14.56c5.72,0,9.4,2.4,11.87,5.84l-5.83,4.52c-1.6-2-3.44-3.28-6.12-3.28-3.92,0-6.68,3.32-6.68,7.4v.08c0,4.2,2.76,7.48,6.68,7.48,2.92,0,4.64-1.36,6.32-3.4l5.84,4.16a14.74,14.74,0,0,1-26.84-8.16Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1560.53,195.19h7.76v10.48h10V195.19H1586v28h-7.75V212.55h-10v10.64h-7.76Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1591.13,195.19h7.8v28h-7.8Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1604.05,195.19h22.51v6.6h-14.83V206h13.43v6.12h-13.43v4.44h15v6.6h-22.71Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1628.49,195.19h8.68l6.36,17.72,6.35-17.72h8.52L1647,223.39h-7.19Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1661.13,195.19h22.51v6.6h-14.83V206h13.43v6.12h-13.43v4.44h15v6.6h-22.71Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1687.81,195.19h8.2l6.67,10.84,6.68-10.84h8.2v28h-7.72V207.11l-7.16,11h-.16l-7.11-10.88v16h-7.6Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1722.53,195.19H1745v6.6h-14.83V206h13.43v6.12h-13.43v4.44h15v6.6h-22.71Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1749.21,195.19h7.24L1768,210v-14.8h7.68v28h-6.8l-12-15.36v15.36h-7.67Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1787.44,202h-8.39v-6.8h24.55V202h-8.4v21.2h-7.76Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><path d="M1804.28,219l4.32-5.16a14.42,14.42,0,0,0,9.08,3.36c2.08,0,3.2-.72,3.2-1.92v-.08c0-1.16-.92-1.8-4.72-2.68-6-1.36-10.56-3-10.56-8.8v-.08c0-5.2,4.12-9,10.84-9a17.62,17.62,0,0,1,11.52,3.72l-3.88,5.48a14,14,0,0,0-7.84-2.76c-1.88,0-2.8.8-2.8,1.8V203c0,1.28,1,1.84,4.84,2.72,6.44,1.4,10.44,3.48,10.44,8.72v.08c0,5.72-4.52,9.12-11.32,9.12A19.56,19.56,0,0,1,1804.28,219Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed;fill-rule:evenodd"/><polygon points="1682.93 513.37 1782.11 487.49 1583.75 487.49 1682.93 513.37" style="fill:#f1f1f1"/><polygon points="263.06 513.37 362.24 487.49 163.88 487.49 263.06 513.37" style="fill:#f1f1f1"/><path d="M191.05,230.1,191,217.34l-6.08,10.24h-4.16l-6.08-9.8V230.1h-8.6v-28h7.76L182.93,217l8.88-14.92h7.76l.08,28Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M204.21,202.1h9.44v28h-9.44Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M216.45,227.86l3-6.88a19.21,19.21,0,0,0,9.24,2.56c2.68,0,3.64-.56,3.64-1.52,0-3.52-15.48-.68-15.48-11.12,0-5.2,4.36-9.44,13-9.44a22.23,22.23,0,0,1,10.56,2.44l-2.84,6.84a17.27,17.27,0,0,0-7.8-2.08c-2.76,0-3.64.8-3.64,1.76,0,3.36,15.48.56,15.48,10.88,0,5.12-4.36,9.44-13,9.44C224,230.74,219.25,229.58,216.45,227.86Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M242.73,227.86l3-6.88a19.21,19.21,0,0,0,9.24,2.56c2.68,0,3.64-.56,3.64-1.52,0-3.52-15.48-.68-15.48-11.12,0-5.2,4.36-9.44,13-9.44a22.23,22.23,0,0,1,10.56,2.44l-2.84,6.84a17.27,17.27,0,0,0-7.8-2.08c-2.76,0-3.64.8-3.64,1.76,0,3.36,15.48.56,15.48,10.88,0,5.12-4.36,9.44-13,9.44C250.25,230.74,245.53,229.58,242.73,227.86Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M270.77,202.1h9.44v28h-9.44Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M283.65,216.1c0-8.48,6.68-14.64,15.8-14.64s15.79,6.16,15.79,14.64-6.67,14.64-15.79,14.64S283.65,224.58,283.65,216.1Zm22.08,0c0-4.36-2.8-7-6.28-7s-6.28,2.64-6.28,7,2.8,7,6.28,7S305.73,220.46,305.73,216.1Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M346.29,202.1v28h-7.76l-10.64-12.72V230.1h-9.2v-28h7.76l10.64,12.72V202.1Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><path d="M349.09,227.86l3-6.88a19.21,19.21,0,0,0,9.24,2.56c2.68,0,3.64-.56,3.64-1.52,0-3.52-15.48-.68-15.48-11.12,0-5.2,4.36-9.44,13-9.44a22.16,22.16,0,0,1,10.55,2.44l-2.83,6.84a17.27,17.27,0,0,0-7.8-2.08c-2.76,0-3.64.8-3.64,1.76,0,3.36,15.48.56,15.48,10.88,0,5.12-4.36,9.44-13,9.44C356.61,230.74,351.89,229.58,349.09,227.86Z" transform="translate(0.5 208.79)" style="fill:#1ec2ed"/><text x="0.5" y="208.79"/><text x="0.5" y="208.79"/></g></g></svg>

       <div id="lottie-desks" ref="animdesks"/>
  <div class="mid-mission-control"> 
    <button class="left-mission" @click='indexDecrease()'><b-icon icon="chevron-left" aria-hidden="true" style="width: 25px; height: 25px; color: #de1a21 !important;"></b-icon></button>
    <h2>{{selectProduct(region,currentAchievementWorld.file_name_url)}}</h2> 
    <button class="right-mission" @click='indexIncrease()'><b-icon icon="chevron-right" aria-hidden="true" style="width: 25px; height: 25px; color: #de1a21 !important;"></b-icon></button>  
  <ul class="mission-left">
    

            <li class="mission">
              <p><toggleCheckOrX :argBool='visitedWorld(currentAchievementWorld.file_name_url)'/>  &nbsp;Visit the {{selectProduct(region,currentAchievementWorld.file_url_name)}} World.</p>
              <p><toggleCheckOrX :argBool='tookFitQuiz(currentAchievementWorld.file_name_url)'/>  &nbsp;Take the assessment in the Explore section of {{selectProduct(region,currentAchievementWorld.file_name_url)}} World.</p>
              <p><toggleCheckOrX :argBool='learnedOneCareer(currentAchievementWorld.file_name_url)'/>  &nbsp;Learn about one career in  {{selectProduct(region,currentAchievementWorld.file_name_url)}} World.</p>
              <p><toggleCheckOrX :argBool='visitedEmployers(currentAchievementWorld.file_name_url)'/>  &nbsp;Visit the Employers section in {{selectProduct(region,currentAchievementWorld.file_name_url)}} World.</p>
              <p><toggleCheckOrX :argBool='visitedEducation(currentAchievementWorld.file_name_url)'/>  &nbsp;Open the Education section in {{selectProduct(region,currentAchievementWorld.file_name_url)}} World.</p>

            </li>
          

    

  </ul>
  <div class="mission-center">
    <h4 style="color: #3cc2ed;">Points Earned: <span style="color:white">{{statusState.totalPoints}} </span></h4>
    <h4 style="color: #3cc2ed;"> Completed Missions: <span style="color:white">{{statusState.totalMissions}} <!--/{{5*this.worldsARRAY.length}} --></span>  </h4>
    <h4 style="color: #3cc2ed;"> Completed Achievements: <span style="color:white">{{statusState.totalAchievements}}<!--/{{(3*this.worldsARRAY.length)+1}}--> </span> </h4>
   <h4 style="color: #3cc2ed;">Badges Earned:
      <div id="badge">
          <b-row>
     
            <b-col cols="2" style="width:200px; padding:0; margin:0" v-for="(badge,index) in earnedBadges" :key="index"><img :src="require(`@/assets/badges/${badge.badgeSrc}-badge.png`)"/></b-col>

           </b-row>
       </div>
    </h4>
  </div>
  <!--div class="mission-center-bottom">
    <b-button @click="missionLogToggleClick" class="neu-button">Submit Mission Log</b-button>
  </div>-->
  <ul class="mission-right">
       <!--<p style="color:white!important"> CARLOS TITLE THING{{currentMissionWorld.url}}</p>

        <button @click='indexDecrease("mi")'>
          up
          </button> -->
            <li class="achievements">
                 <p><toggleCheckOrX :argBool='visitedAllPages(currentAchievementWorld.file_name_url)'/> &nbsp;Visit the Explore, Careers, Employers, and Education sections in {{selectProduct(region,currentAchievementWorld.file_name_url)}}. </p>
                <p><toggleCheckOrX :argBool='learnedAllCareers(currentAchievementWorld.file_name_url)'/>  &nbsp;Learn about all of the careers in {{selectProduct(region,currentAchievementWorld.file_name_url)}} World. </p>
                <p><toggleCheckOrX :argBool='allMissionsAchievementsComplete(currentAchievementWorld.file_name_url)'/>  &nbsp;Complete all of the achievements and missions in {{selectProduct(region,currentAchievementWorld.file_name_url)}}. (Awards badge)</p>
            </li><!--<achievementToggle/>-->


    </ul>
     </div>   
<!--
  <div :class="isActive ? 'show-box' : 'hid-box'"  id="missionLog">
    <button v-if="ipadUp && isActive "  :class="ipadUp ? 'back-button show-button' : 'back-button hid-button'"  @click="ipadDown"><b-icon icon="chevron-down" aria-hidden="true" style="width: 42px; height: 42px; color: #de1a21 !important;"></b-icon></button>
  <svg id="backTablet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1903.48 898.74"><defs><linearGradient id="linear-gradient" x1="3.86" y1="452.7" x2="1903.92" y2="452.7" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#b2b2b2"/><stop offset="0.63" stop-color="#ddd"/><stop offset="1" stop-color="#f1f1f1"/></linearGradient><clipPath id="clip-path" transform="translate(-3.36 -0.63)"><path d="M1882.2,259.15V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.24,15.24,0,0,0-4.47,10.78V829.9a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,259.15ZM1725.66,781.53h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0A64.4,64.4,0,0,1,154.93,736V203.46A64.36,64.36,0,0,1,173.78,158h0a64.36,64.36,0,0,1,45.51-18.85H1680.15A64.36,64.36,0,0,1,1725.66,158h0a64.37,64.37,0,0,1,18.86,45.51V736A64.41,64.41,0,0,1,1725.66,781.53Z" style="fill:none"/></clipPath><radialGradient id="radial-gradient" cx="953.89" cy="449.1" r="742.32" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="0.6" stop-color="#eee"/><stop offset="0.97" stop-color="#e6e6e6"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient><radialGradient id="radial-gradient-2" cx="953.89" cy="449.1" r="742.79" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f1f1f1"/><stop offset="1" stop-color="#e5e5e5"/></radialGradient></defs><path d="M1882.2,262.75V76a15.27,15.27,0,0,0-4.46-10.78L1823,10.49A15.26,15.26,0,0,0,1812.24,6H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165A15.21,15.21,0,0,0,154.27,22l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,73a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,152.56a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8A15.25,15.25,0,0,0,39.29,335l.23.23A15.25,15.25,0,0,1,44,346V479.49a15.25,15.25,0,0,1-4.47,10.78h0A15.22,15.22,0,0,0,35.06,501V754a15.21,15.21,0,0,1-4.47,10.77L8.33,787.05a15.24,15.24,0,0,0-4.47,10.78V833.5a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V297.1a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,262.75ZM1725.66,785.13h0A64.36,64.36,0,0,1,1680.15,804H219.29a64.36,64.36,0,0,1-45.51-18.85h0a64.4,64.4,0,0,1-18.85-45.52V207.06a64.36,64.36,0,0,1,18.85-45.51h0a64.36,64.36,0,0,1,45.51-18.85H1680.15a64.36,64.36,0,0,1,45.51,18.85h0a64.37,64.37,0,0,1,18.86,45.51V739.61A64.41,64.41,0,0,1,1725.66,785.13Z" transform="translate(-3.36 -0.63)" style="fill:url(#linear-gradient)"/><rect x="97.35" y="70.06" width="1722.92" height="774.59" style="fill:#fff;opacity:0.5"/><path d="M1882.2,257.35V70.6a15.27,15.27,0,0,0-4.46-10.78L1823,5.09A15.26,15.26,0,0,0,1812.24.63H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,67.58a15.25,15.25,0,0,0-4.47,10.78V131H27L10.85,147.16a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77L27.18,286h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,340.61V474.09a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,781.65a15.24,15.24,0,0,0-4.47,10.78V828.1a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V291.7a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,257.35ZM1725.66,779.73h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0a64.4,64.4,0,0,1-18.85-45.52V201.66a64.36,64.36,0,0,1,18.85-45.51h0a64.36,64.36,0,0,1,45.51-18.85H1680.15a64.36,64.36,0,0,1,45.51,18.85h0a64.37,64.37,0,0,1,18.86,45.51V734.21A64.41,64.41,0,0,1,1725.66,779.73Z" transform="translate(-3.36 -0.63)" style="fill:#e5e5e5"/><rect id="opacity-fill" x="108.31" y="93.55" width="1697.52" height="738.8" style="fill:#fff;opacity:0.98"/><g style="clip-path:url(#clip-path)"><path d="M1882.2,259.15V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.34h7.64v32.8a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78h0a15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.24,15.24,0,0,0-4.47,10.78V829.9a15.24,15.24,0,0,0,4.47,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79A15.29,15.29,0,0,1,1882.2,259.15ZM1725.66,781.53h0a64.36,64.36,0,0,1-45.51,18.85H219.29a64.36,64.36,0,0,1-45.51-18.85h0A64.4,64.4,0,0,1,154.93,736V203.46A64.36,64.36,0,0,1,173.78,158h0a64.36,64.36,0,0,1,45.51-18.85H1680.15A64.36,64.36,0,0,1,1725.66,158h0a64.37,64.37,0,0,1,18.86,45.51V736A64.41,64.41,0,0,1,1725.66,781.53Z" transform="translate(-3.36 -0.63)" style="stroke-miterlimit:10;fill:url(#radial-gradient);stroke:url(#radial-gradient-2)"/><path d="M101.66,478.66l-34,34a4.13,4.13,0,0,0-1.2,2.91V713a4.11,4.11,0,0,0,7,2.91l31.81-31.81a4.12,4.12,0,0,0,1.21-2.87l2.14-199.64A4.11,4.11,0,0,0,101.66,478.66Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M73.5,460.06,92.25,441.3a4.1,4.1,0,0,0,1.21-2.9V370a4.14,4.14,0,0,0-1.21-2.91l-19-19a4.1,4.1,0,0,0-7,2.91l.22,106.12A4.11,4.11,0,0,0,73.5,460.06Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M16.82,289.62h95.33a4,4,0,0,0,4-4V174.51a4,4,0,0,0-1.17-2.83L78.16,134.86a4,4,0,0,0-2.83-1.17H20.6" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1282.82,1.61l-42.64,42.64a4,4,0,0,1-2.83,1.17H373.05a4,4,0,0,0-2.83,1.17L346.37,70.44a4,4,0,0,1-2.83,1.17H228.22a4,4,0,0,1-2.84-1.17l-25.6-25.61A4,4,0,0,0,197,43.66H130.78l-4.94-4.94" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M463.29,140.9,493,111.22a4,4,0,0,1,2.83-1.17h820.57l11.36-11.36h91.84a4,4,0,0,0,2.83-1.17l52.46-52.46a4,4,0,0,1,2.83-1.17h58.07a4,4,0,0,1,2.83,6.83l-91.75,91.75" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,93.18l-35,35A4,4,0,0,0,1846,131V271a4,4,0,0,0,1.17,2.83l30.6,30.6a4,4,0,0,1,1.17,2.83V442a4,4,0,0,1-1.17,2.83l-96.73,96.73a4,4,0,0,0-1.17,2.83V705.64a4,4,0,0,1-1.17,2.84l-35,35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1903.92,477.23l-76.27,76.28a4,4,0,0,0-1.18,2.83V727a4,4,0,0,0,1.18,2.83L1904.82,807" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1651.3,878.87l-37.78-37.79a4,4,0,0,0-2.83-1.17H427.28a4,4,0,0,0-2.83,1.17l-37.4,37.41" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M157.89,892.39l-29.14-29.14a4,4,0,0,1,0-5.66L162.32,824a4,4,0,0,1,2.83-1.17H1667a4,4,0,0,1,2.83,1.17l38.12,38.12a4,4,0,0,0,2.83,1.17h166.81" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,508.4l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,544.18Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,564.12l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,599.9Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,619.84l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,655.62Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,115.73l-17.54,17.54a4.12,4.12,0,0,0-1.2,2.91v90.63a4.09,4.09,0,0,0,1.2,2.9l17.54,17.54Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M101.66,476.86l-34,34a4.13,4.13,0,0,0-1.2,2.91v197.5a4.11,4.11,0,0,0,7,2.91l31.81-31.81a4.12,4.12,0,0,0,1.21-2.87l2.14-199.64A4.11,4.11,0,0,0,101.66,476.86Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M73.5,458.26,92.25,439.5a4.1,4.1,0,0,0,1.21-2.9V368.21a4.14,4.14,0,0,0-1.21-2.91l-19-19a4.1,4.1,0,0,0-7,2.91l.22,106.12A4.11,4.11,0,0,0,73.5,458.26Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M16.82,287.82h95.33a4,4,0,0,0,4-4V172.71a4,4,0,0,0-1.17-2.83L78.16,133.06a4,4,0,0,0-2.83-1.17H20.6" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1281,1.61l-40.84,40.84a4,4,0,0,1-2.83,1.17H373.05a4,4,0,0,0-2.83,1.17L346.37,68.64a4,4,0,0,1-2.83,1.17H228.22a4,4,0,0,1-2.84-1.17L199.78,43A4,4,0,0,0,197,41.86H130.78l-3.35-3.35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M463.29,139.1,493,109.42a4,4,0,0,1,2.83-1.17h820.57l11.36-11.36h91.84a4,4,0,0,0,2.83-1.17l52.46-52.46a4,4,0,0,1,2.83-1.17h58.07a4,4,0,0,1,2.83,6.83l-91.75,91.75" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,91.38l-35,35a4,4,0,0,0-1.17,2.83V269.16a4,4,0,0,0,1.17,2.83l30.6,30.6a4,4,0,0,1,1.17,2.83V440.18a4,4,0,0,1-1.17,2.83l-96.73,96.73a4,4,0,0,0-1.17,2.83V703.84a4,4,0,0,1-1.17,2.84l-35,35" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1903.92,475.43l-76.27,76.28a4,4,0,0,0-1.18,2.83V725.22a4,4,0,0,0,1.18,2.83l77.17,77.18" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1653.42,879.19l-39.9-39.91a4,4,0,0,0-2.83-1.17H427.28a4,4,0,0,0-2.83,1.17l-39.2,39.21" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M159.51,892.2l-30.76-30.75a4,4,0,0,1,0-5.66l33.57-33.57a4,4,0,0,1,2.83-1.17H1667a4,4,0,0,1,2.83,1.17l38.12,38.12a4,4,0,0,0,2.83,1.17h166.81" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,506.6l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,542.38Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,562.32l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,598.1Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1904.82,618l-54.28,54.28a4.13,4.13,0,0,0-1.21,2.91v25.33a4.11,4.11,0,0,0,7,2.9L1906,653.82Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/><path d="M1882.2,113.93l-17.54,17.54a4.12,4.12,0,0,0-1.2,2.91V225a4.09,4.09,0,0,0,1.2,2.9l17.54,17.54Z" transform="translate(-3.36 -0.63)" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.71274042129517px"/></g><path d="M1812.24,2.93a14.64,14.64,0,0,1,10.42,4.32L1877.38,62a14.64,14.64,0,0,1,4.32,10.43V259.15a15.63,15.63,0,0,0,4.61,11.13l12.79,12.79a14.64,14.64,0,0,1,4.32,10.43V824.9a14.6,14.6,0,0,1-4.32,10.42L1843.47,891a14.6,14.6,0,0,1-10.42,4.32H1701.66a14.64,14.64,0,0,1-10.43-4.32l-9.77-9.77a15.61,15.61,0,0,0-11.13-4.61H368.61a15.63,15.63,0,0,0-11.13,4.61l-4.59,4.59a14.68,14.68,0,0,1-10.42,4.32H64.55a14.69,14.69,0,0,1-10.43-4.32L8.68,840.33A14.68,14.68,0,0,1,4.37,829.9V794.23A14.68,14.68,0,0,1,8.68,783.8L31,761.54a15.67,15.67,0,0,0,4.61-11.13v-253A14.67,14.67,0,0,1,39.87,487a15.62,15.62,0,0,0,4.62-11.13V342.41a15.6,15.6,0,0,0-4.62-11.13l-.23-.24a14.64,14.64,0,0,1-4.32-10.42V287.81a.5.5,0,0,0-.5-.5H27.39L11.2,271.13a14.66,14.66,0,0,1-4.32-10.42v-101a14.64,14.64,0,0,1,4.32-10.42l16-16h7.61a.5.5,0,0,0,.5-.5V80.16a14.64,14.64,0,0,1,4.32-10.42L62.7,46.68a14.62,14.62,0,0,1,10.42-4.32h51.35a15.65,15.65,0,0,0,11.13-4.61l19-19A14.6,14.6,0,0,1,165,14.41h1083.9a15.67,15.67,0,0,0,11.13-4.61l2.55-2.55A14.62,14.62,0,0,1,1273,2.93h539.2m-1592.95,798H1680.15A64.87,64.87,0,0,0,1745,736V203.46a64.87,64.87,0,0,0-64.87-64.86H219.29a64.87,64.87,0,0,0-64.86,64.86V736a64.87,64.87,0,0,0,64.86,64.87m1593-798.45H1273a15.24,15.24,0,0,0-10.77,4.46l-2.56,2.56a15.2,15.2,0,0,1-10.77,4.46H165a15.21,15.21,0,0,0-10.77,4.47l-19,19a15.24,15.24,0,0,1-10.77,4.46H73.12a15.24,15.24,0,0,0-10.77,4.46L39.29,69.38a15.25,15.25,0,0,0-4.47,10.78v52.65H27L10.85,149a15.25,15.25,0,0,0-4.47,10.78v101a15.23,15.23,0,0,0,4.47,10.77l16.33,16.33h7.64v32.81a15.25,15.25,0,0,0,4.47,10.78l.23.23A15.25,15.25,0,0,1,44,342.41V475.89a15.25,15.25,0,0,1-4.47,10.78,15.22,15.22,0,0,0-4.46,10.77v253a15.21,15.21,0,0,1-4.47,10.77L8.33,783.45a15.23,15.23,0,0,0-4.46,10.78V829.9a15.23,15.23,0,0,0,4.46,10.78l45.44,45.44a15.24,15.24,0,0,0,10.78,4.47H342.47a15.23,15.23,0,0,0,10.77-4.47l4.6-4.59a15.2,15.2,0,0,1,10.77-4.46H1670.33a15.24,15.24,0,0,1,10.78,4.46l9.77,9.78a15.29,15.29,0,0,0,10.78,4.46h131.39a15.29,15.29,0,0,0,10.78-4.46l55.63-55.63a15.29,15.29,0,0,0,4.46-10.78V293.5a15.29,15.29,0,0,0-4.46-10.78l-12.8-12.79a15.29,15.29,0,0,1-4.46-10.78V72.4a15.27,15.27,0,0,0-4.46-10.78L1823,6.89a15.26,15.26,0,0,0-10.77-4.46Zm-1592.95,798A64.36,64.36,0,0,1,154.93,736V203.46a64.36,64.36,0,0,1,64.36-64.36H1680.15a64.37,64.37,0,0,1,64.37,64.36V736a64.37,64.37,0,0,1-64.37,64.37Z" transform="translate(-3.36 -0.63)" style="fill:#989898"/><rect x="321.2" y="97.1" width="17.71" height="16.79" style="fill:#15a1c1"/><rect x="297.71" y="97.1" width="17.71" height="16.79" style="fill:#15a1c1"/><rect x="274.22" y="97.1" width="17.71" height="16.79" style="fill:#175e70"/><rect x="250.73" y="97.1" width="17.71" height="16.79" style="fill:#175e70"/><rect x="227.24" y="97.1" width="17.71" height="16.79" style="fill:#d81f2b"/><rect x="1837.6" y="318" width="16.79" height="17.71" style="fill:#15a1c1"/><rect x="1837.6" y="341.49" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="364.98" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="388.48" width="16.79" height="17.71" style="fill:#d81f2b"/><rect x="1837.6" y="411.97" width="16.79" height="17.71" style="fill:#b22025"/><circle cx="55.99" cy="174.61" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="172.81" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="172.81" r="10.49" style="fill:#15a1c1"/><circle cx="55.99" cy="209.56" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="207.76" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="207.76" r="10.49" style="fill:#d81f2b"/><circle cx="55.99" cy="244.51" r="10.49" style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="242.71" r="10.49" style="fill:none;stroke:#989898;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"/><circle cx="55.99" cy="242.71" r="10.49" style="fill:#d81f2b"/></svg>
  <div id="formpage">

  <div>
  <b-tabs pills content-class="mt-3" class="form-tabs">
    
    <b-tab  v-for="(page,index) in worldsARRAY"  :key="index"   :class="{ active: index === 0}">
      <template #title>
         {{selectProduct(region,page.url)}}
         <b-icon-check-square-fill v-if="completedQuiz(bigforms[page.url].formstate)" variant="success" style="width:15px; height: 15px;" ></b-icon-check-square-fill> <b-icon-x-square-fill  v-else variant="danger" style="width:15px; height: 15px;"></b-icon-x-square-fill>
      </template>
      <h4 style="color:#0e2332"> {{selectProduct(region,page.file_url_name)}} Questions</h4>
  
  
      <p> {{ assessmentInfo[page.url].question1.questionText}} :{{bigforms[page.url].formstate.question1.questionAnswer}}</p>
      <p> {{ assessmentInfo[page.url].question2.questionText}} :{{bigforms[page.url].formstate.question2.questionAnswer}}</p>
      <p> {{ assessmentInfo[page.url].question3.questionText}} :{{bigforms[page.url].formstate.question3.questionAnswer}}</p>
      <p> {{ assessmentInfo[page.url].question4.questionText}} :{{bigforms[page.url].formstate.question4.questionAnswer}}</p>






  
    </b-tab>

   
  </b-tabs>
</div>
<hr v-if="region=='sawdc'">
<p v-if="region=='sawdc'">
Visit at least five worlds to be entered into a drawing to win a prize. 
</p>
<hr>
    <div>
    <b-tab v-for="(page,index) in worldsARRAY"  :key="index"  :class="{ active: index === 0}">
    <b-tabs pills content-class="mt-3">
      
     {{page.url}}
   }
    </b-tabs>
    </b-tab>
  </div>
<hr>
Earned points: {{earnedPoints}}
<br>
Missions:{{completedMissions}}
<br/>
Achievements:{{completedAchievements}}
<br/>
Badge Count: {{earnedBadges.length}}
<br/>
  <hr>
  
  <h4 style="color:#0e2332"> Enter your information below to send this assessment to your teacher</h4> 
  <hr>

    <span>Teacher Email</span>: <input v-model="teacher_email"/>
    <br/>
  <span>Teacher Name</span>: <input v-model="teacher_name"/>
    <br/>

   <span>Grade Level</span>:  <span ><b-form-select v-model="grade_level" :options="gradeOptions" size="sm" class=""></b-form-select></span>
<br/>
 <span style="float:left;margin-top: 1vh;margin-right: 0.2vw;">School :&nbsp; </span>
<span v-if="isSchoolListed" style="" class="school-listing" >
   <SearchAutocomplete 
      :items='schoolInfoArray'
    />
    </span>
    <span class="school-listing school-active" ><input v-if="!isSchoolListed" v-model="school_name"/></span>

  <b-button class="toggle-school" @click="toggleisSchoolListed">My School Isn't Listed </b-button>
  <br/>

    <br/>

  <span>Student Name</span>: <input v-model="student_name"/>
  <br/>
  <span v-if="region=='sawdc'">Student Email</span>: <input  v-if="region=='sawdc'" v-model="student_email"/>

  <br/>
  <div style="box-shadow: inset 2px 2px 5px #B8B9BE, inset -3px -3px 7px #fff; width: 50%; padding:15px; margin-top: 20px; margin-bottom:0px;">
  <p><b>Email Preview</b></p>
  Teacher Email: {{teacher_email}}
  
  <br/>

  Teacher Name: {{teacher_name}}
    <br/>
  Grade Level: {{grade_level}}
  <br/>
  School: {{school_name}}
    <br/>
    
  Student Name: {{student_name}}
      <br/>
      
    <span v-if="region=='sawdc'">
      Student Email: {{student_email}}
      </span>
  </div>
  <br/>

  <button  v-if="!spinnerActive" class="neu-button" @click="sendEmail"> send email</button>

  <b-button class="neu-button" v-if="spinnerActive==true" variant="primary" disabled>
    <b-spinner small type="grow"></b-spinner>
    ...Sending
  </b-button>

  </div>
</div>  

-->
</div>
</template>

<script>


//import { mapActions } from 'vuex'
import emailjs from 'emailjs-com';
//import { BIconCheckSquareFill, BIconXSquareFill } from 'bootstrap-vue'
  import worldNameMixin from '../shared_methods/worldname_mixin';
  import regionWorldMixin from '../shared_methods/regionworlds_mixin';
import toggleCheckOrX from '../components/handheld_components/toggleCheckOrX';
import Lottie from 'lottie-web';
//import SearchAutocomplete from '../components/searchAutocomplete';
import {mapGetters,} from 'vuex'

import schoolInfoMixin from '../shared_methods/schoolInfoMixin';
import careersInfoMixin from '../shared_methods/careers_Info_Mixin';
import assessmentMixin from '../shared_methods/assessmentMixin';
import EmailEntryDataService from "../_services/emailEntryDataService";
import formattingMixin from '../shared_methods/formattingMixin';
let unsubscribe;

export default {
  name: 'FormHome',
  mixins: [worldNameMixin,regionWorldMixin,schoolInfoMixin,careersInfoMixin,assessmentMixin,formattingMixin],
  data: function() {
 console.log(this.$store.state.conversations.handheld)
        //const formstate= this.$store.state
           var worldsarray=this.selectRegionWorlds(process.env.VUE_APP_CURRENT_REGION)
           const schoolInfo=this.selectSchoolInfo(process.env.VUE_APP_CURRENT_REGION);
           //const allMissions=this.$store.state.handheld.totalMissions;
          //const allAchievements=t.totalAchievements;
     const assessmentRegionInfo = this.selectAssessmentRegionInfo(process.env.VUE_APP_CURRENT_REGION)

          // var missionsCount=0
        //   var achievementsCount=4
/*
           for (var i = 0; i < worldsarray.length; i++) { 
                //console.warn(allMissions[worldsarray[i].url].length)
                missionsCount+=allMissions[worldsarray[i].url].length;
                achievementsCount+=allAchievements[worldsarray[i].url].length;
               

           }*/
           const schoolInfoArray=schoolInfo.schools.map(schoolItem => {
             return schoolItem.name});
//console.log("school"+schoolInfo)
////console.log(formstate[process.env.VUE_APP_CURRENT_REGION.toLowerCase()])
      return{
                ipadUp:true,
                statusState:"",
            isSchoolListed:true,
          teacher_email:"",
          teacher_name:"",
          student_name:"",
          school_name:"",
          grade_level:"",
          student_email:"",
          spinnerActive:false,
          schoolInfoArray:schoolInfoArray,
         bcc:{
           sawdc:"info@sawdc.org",
              eaw:"wow@eastalabamaworks.com",
                caw:"careerdiscovery2021@gmail.com",
                waw:"brittani@westalabamachamber.com"
           },
    // declare question3: with an empty value
    completedMissions: 4,
    completedAchievements: 4,//this.$store.state.awards_tracking.currentSession.completedAchievements.length,
    earnedBadges:"",
    earnedPoints:5,
  gradeOptions: [

          { value: "8th Grade", text: '8th Grade' },
          { value: "9th Grade", text: '9th Grade' },
          { value: "10th Grade", text: '10th Grade' },
          { value: "11th Grade", text: '11th Grade' },
          { value: "12th Grade", text: '12th Grade' },

        ],
    //bigforms:formstate[process.env.VUE_APP_CURRENT_REGION.toLowerCase()],
        worldsARRAY:worldsarray,
        region:process.env.VUE_APP_CURRENT_REGION.toLowerCase(),
         assessmentInfo:assessmentRegionInfo,
         isActive:false,
         selectorIndex:0
      }
  },
  computed: {
  
    ...mapGetters('user', ['currentUser']),
   // ...mapState('prog_tracking', ['world_info']),



    currentAchievementWorld(){
      return this.worldsARRAY[this.selectorIndex]
    },
    currentMissionWorld(){
      return this.worldsARRAY[this.selectorIndex]
    },
    bigform() {
          const formstate=this.$store.state.assessment_form_store;
          const bigFormArray=[]
          Object.keys(formstate).map(function(objectKey, index) {
            //console.log(objectKey);
            var value = formstate[objectKey];
            //console.log(index);
            value['worldName']=objectKey;
            value['index']=index;
            bigFormArray.push(value);
        });
        //console.log(bigFormArray)
        return bigFormArray
      },


    }
  ,components:{

   toggleCheckOrX,
    //LottieAnimation
//SearchAutocomplete
   // BIconXSquareFill,
    //BIconCheckSquareFill
  },  beforeMount(){
    console.warn("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$GGGGGGGGGGGGGGGGGSSSSSSSSSSSSSSSSSSSSSSS")
    console.log(this)
     const { currentUser } = this
    //console.log(currentUser)
    console.log(this)
    if (currentUser) {
      // Hide the loading screen if currentUser
      // is available before the page renders
      //this.$q.loading.hide()
      //this.getDataFromApi(this.currentUser.id)
      //console.log(currentUser)
         // this.init();
   
      //    if (this.pauseAmbient ==true)
      //    {
    //      this.$parent.$parent.restartAmbient()

     //     }
     unsubscribe = this.$fb.collectionRef('status').doc(currentUser.id).onSnapshot(status => {
				//eslint-disable-next-line no-unused-vars
				let source = status.metadata.hasPendingWrites ? 'Local' : 'Server'
          if (status && status.data()) {
           
            console.log(status.data())
            console.warn("DDATA")
            const dbState=status.data()
            this.statusState=dbState
            this.earnedBadges=dbState.badges
            this.$store.commit('conversations/SET_HANDHELD'
          , {dbState}
           )
           this.sideLoaded=true
            //this.statusChange();
          }
     })
     console.log(unsubscribe);
      }


  },mounted(){

   

    console.log(this.$store)
             this.init()

      },
      beforeDestroy(){


      
  
    unsubscribe();
 

          Lottie.destroy(this.animName);
      },
  methods: {   
     setSchool(school){
    //console.log(school)
   this.school_name=school;
     },      
    toggleisSchoolListed(){
    this.isSchoolListed = !this.isSchoolListed
  },
  saveEmailEntry() {

      try {
const timeElapsed = Date.now();
const today = new Date(timeElapsed);
            var worldsInfo= {
            }
      for (var i = 0; i < this.worldsARRAY.length; i++) {
            //console.log(i);
            const currentWorld=this.worldsARRAY[i]
            // more statements
            console.log(currentWorld.url);
            console.log(this.assessmentInfo)
            worldsInfo["world"+i]={}
            worldsInfo["world"+i]["name"]=this.selectProduct(this.region,currentWorld.file_name_url)
            
            worldsInfo["world"+i]["q1"]=this.assessmentInfo[currentWorld.file_name_url].question1.questionText
            worldsInfo["world"+i]["a1"]=this.bigforms[currentWorld.file_name_url].formstate.question1.questionAnswer
            
            worldsInfo["world"+i]["a2"]=this.bigforms[currentWorld.file_name_url].formstate.question2.questionAnswer
            worldsInfo["world"+i]["q2"]=this.assessmentInfo[currentWorld.file_name_url].question2.questionText
        
            worldsInfo["world"+i]["a3"]=this.bigforms[currentWorld.file_name_url].formstate.question3.questionAnswer
            worldsInfo["world"+i]["q3"]=this.assessmentInfo[currentWorld.file_name_url].question3.questionText
            
            worldsInfo["world"+i]["q4"]=this.assessmentInfo[currentWorld.file_name_url].question4.questionText
            worldsInfo["world"+i]["a4"]=this.bigforms[currentWorld.file_name_url].formstate.question4.questionAnswer


            }


      var data = {
       to_name: this.student_name,
                to_email:this.teacher_email,
                bcc:this.bcc[this.region],
                student_name:this.student_name,
                teacher_name:this.teacher_name,
                school_name:this.school_name,
                grade_level:this.grade_level,
                points:this.earnedPoints,
                achievements:this.completedAchievements,
                missions:this.completedMissions,
                badge_count:this.earnedBadges.length,
                student_email:this.student_email,
                submission_time:Date.now(),
                date_time_string:today.toDateString(),
                worlds_info:worldsInfo
      };

      EmailEntryDataService.create(data,this.region)
        .then(() => {
          console.log("Created new item successfully!");
          this.submitted = true;
        })
        .catch(e => {
                               this.$bvToast.toast(`${e}`, {
                        title: `Email Failed`,
                        autoHideDelay: 5000,
                        appendToast: true
                      })     
          console.log(e);
        });
      }
                        catch (exception_var) {
                           this.spinnerActive=false;

                        this.$bvToast.toast(`db storage error`, {
                        title: `Email Failed`,
                        autoHideDelay: 5000,
                        appendToast: true
                      })                  }
    },
    ipadDown(){
     this.isActive=false;
     this.ipadUp=false;
    },
          indexIncrease(){
          if(this.selectorIndex< (this.worldsARRAY.length-1))
          {
          this.selectorIndex ++

          }
          else
          {
              this.selectorIndex=0;
          }
      },
      indexDecrease(){
                    

          if(this.selectorIndex > 0)
          {
          this.selectorIndex--;

          }
          else
          {
             this.selectorIndex=this.worldsARRAY.length-1;
          }
      },
          init() {
      // Grab the current world's animation data
      const animationData = JSON.parse(JSON.stringify(require(`@/assets/mission-control/mission-control-desks.json`)));

      this.anim = Lottie.loadAnimation({
        container: document.getElementById('lottie-desks'), // TODO: Using Vue ref needs to be debugged
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
        name: this.animName
      });
    },

    visitedWorld(worldname) {
      try{
          console.warn("WNN"+worldname)
        const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
        const pageVisited= worldState.pageVisited 
        console.warn(pageVisited)

        console.log(this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)])
      return pageVisited;
      
    }
    catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    console.log(this.statusState)

        return false
      }
    },
    visitedEmployers(worldname){
      try{

      const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
      const sidebarElementName= worldState.visitedSidebarElementName
      return sidebarElementName.indexOf('Employers') > -1 
    }
    catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return false
      }
    },
    visitedEducation(worldname){
      try{
      const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
      const sidebarElementName= worldState.visitedSidebarElementName
      return sidebarElementName.indexOf('Education') > -1
    }
    catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return false
      }
    },

    tookFitQuiz(worldname) {
      try{
      const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
      const suitabilityQuizTaken= worldState.suitabilityAssessmentTaken
      return suitabilityQuizTaken
    }
    catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return true
      }     
    },
    visitedAllPages(worldname){
      try{
      const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
      const sidebarElementName = worldState.visitedSidebarElementName;
      return  sidebarElementName.length>=4 ?? false;
    }
    catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return true
      }
    },
    learnedAllCareers(worldname)
    {
      try{
        const jobPageInfo = this.selectJobPageInfo(process.env.VUE_APP_CURRENT_REGION,worldname);
        const jobCount=  jobPageInfo.jobs.length
      const careersLearned=this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)].careersLearned
      console.log(careersLearned)
      return careersLearned.length >= jobCount ?? false;
      }
      catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return  false
      }
    },



 
    learnedOneCareer(worldname)
    {
      try{
        console.warn("WGFF" +worldname)
        const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
        
        console.log(worldState)
      const careersLearned = worldState.careersLearned
      return careersLearned.length >= 1 
      }
      catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return  false
      }

    },

    allMissionsAchievementsComplete(worldname)
    { //TODO MAKE IT BETTER
      try{
        const worldState =this.$store.state.conversations.handheld.worldsStatus[this.worldNameToDbNameFormat(worldname)]
      const completedAchievements = worldState.complete_achievements;
      const completedMissions = worldState.complete_missions;
      return ((completedAchievements.length>=2) &&
      (completedMissions.length>=5)) ?? false
      }
      catch (e) {
    console.log("Error", e.stack);
    console.log("Error", e.name);
    console.log("Error", e.message);
    

        return  false
      }
    },
        missionLogToggleClick(){
          if (this.isActive == false){
               this.isActive= !this.isActive;
               this.ipadUp=true;
          }
          
        },

          sendEmail(){
                                          this.spinnerActive=true;

            try {

             this.saveEmailEntry();
              //console.log(this.bcc[this.region])
            var templateParams = {
                name: this.student_name,
                to_email:this.teacher_email,
                bcc:this.bcc[this.region],
                from_name:this.student_name,
                to_name:this.teacher_name,
                school_name:this.school_name,
                grade_level:this.grade_level,
                points:this.earnedPoints,
                achievements:this.completedAchievements,
                missions:this.completedMissions,
                badge_count:this.earnedBadges.length,
                student_email:this.student_email,
                var_message:"new assessment",
                error:"",
                world0_name:"",
                world0_q1: "",
                world0_q2: "",
                world0_q3: "",
                world0_q4: "",
                world0_a1: "",
                world0_a2: "",
                world0_a3: "",
                world0_a4: "",
                //aero world Q =A
                world1_name:"",
                world1_q1: "",
                world1_q2: "",
                world1_q3: "",
                world1_q4: "",
                world1_a1: "",
                world1_a2: "",
                world1_a3: "",
                world1_a4: "",
                //world2//
                world2_name:"",
                world2_q1: "",
                world2_q2: "",
                world2_q3: "",
                world2_q4: "",
                world2_a1: "",
                world2_a2: "",
                world2_a3: "",
                world2_a4: "",
                //world3//
                                //world2//
                world3_name:"",
                world3_q1: "",
                world3_q2: "",
                world3_q3: "",
                world3_q4: "",
                world3_a1: "",
                world3_a2: "",
                world3_a3: "",
                world3_a4: "",
                //world4//
                world4_name:"",
                world4_q1: "",
                world4_q2: "",
                world4_q3: "",
                world4_q4: "",
                world4_a1: "",
                world4_a2: "",
                world4_a3: "",
                world4_a4: "",
                //world5//
                world5_name:"",
                world5_q1: "",
                world5_q2: "",
                world5_q3: "",
                world5_q4: "",
                world5_a1: "",
                world5_a2: "",
                world5_a3: "",
                world5_a4: "",
                //world6//
                world6_name:"",
                world6_q1: "",
                world6_q2: "",
                world6_q3: "",
                world6_q4: "",
                world6_a1: "",
                world6_a2: "",
                world6_a3: "",
                world6_a4: "",               
                //world7//
                world7_name:"",
                world7_q1: "",
                world7_q2: "",
                world7_q3: "",
                world7_q4: "",
                world7_a1: "",
                world7_a2: "",
                world7_a3: "",
                world7_a4: "",
                //world8//
                world8_name:"",
                world8_q1: "",
                world8_q2: "",
                world8_q3: "",
                world8_q4: "",
                world8_a1: "",
                world8_a2: "",
                world8_a3: "",
                world8_a4: "",
                //world9//
                world9_name:"",
                world9_q1: "",
                world9_q2: "",
                world9_q3: "",
                world9_q4: "",
                world9_a1: "",
                world9_a2: "",
                world9_a3: "",
                world9_a4: "",
                //world10//
                world10_name:"",
                world10_q1: "",
                world10_q2: "",
                world10_q3: "",
                world10_q4: "",
                world10_a1: "",
                world10_a2: "",
                world10_a3: "",
                world10_a4: "",
                //world11//
                world11_name:"",
                world11_q1: "",
                world11_q2: "",
                world11_q3: "",
                world11_q4: "",
                world11_a1: "",
                world11_a2: "",
                world11_a3: "",
                world11_a4: "",
                //world12//
                world12_name:"",
                world12_q1: "",
                world12_q2: "",
                world12_q3: "",
                world12_q4: "",
                world12_a1: "",
                world12_a2: "",
                world12_a3: "",
                world12_a4: "",
                //world13//
                world13_name:"",
                world13_q1: "",
                world13_q2: "",
                world13_q3: "",
                world13_q4: "",
                world13_a1: "",
                world13_a2: "",
                world13_a3: "",
                world13_a4: "",
                //world14//
                world14_name:"",
                world14_q1: "",
                world14_q2: "",
                world14_q3: "",
                world14_q4: "",
                world14_a1: "",
                world14_a2: "",
                world14_a3: "",
                world14_a4: "",
                //world15//                
                world15_name:"",
                world15_q1: "",
                world15_q2: "",
                world15_q3: "",
                world15_q4: "",
                world15_a1: "",
                world15_a2: "",
                world15_a3: "",
                world15_a4: "",
            };
            for (var i = 0; i < this.worldsARRAY.length; i++) {
            //console.log(i);
            const currentWorld=this.worldsARRAY[i]
            // more statements
            console.log(currentWorld.file_name_url);
            console.log(this.assessmentInfo)
            templateParams["world"+i+"_name"]=this.selectProduct(this.region,currentWorld.file_name_url)
            templateParams["world"+i+"_q1"]=this.assessmentInfo[currentWorld.file_name_url].question1.questionText
            templateParams["world"+i+"_q2"]=this.assessmentInfo[currentWorld.file_name_url].question2.questionText
            templateParams["world"+i+"_q3"]=this.assessmentInfo[currentWorld.file_name_url].question3.questionText
            templateParams["world"+i+"_q4"]=this.assessmentInfo[currentWorld.file_name_url].question4.questionText
            
            templateParams["world"+i+"_a1"]=this.bigforms[currentWorld.file_name_url].formstate.question1.questionAnswer
            templateParams["world"+i+"_a2"]=this.bigforms[currentWorld.file_name_url].formstate.question2.questionAnswer
            templateParams["world"+i+"_a3"]=this.bigforms[currentWorld.file_name_url].formstate.question3.questionAnswer
            templateParams["world"+i+"_a4"]=this.bigforms[currentWorld.file_name_url].formstate.question4.questionAnswer


            }
   
            //console.log(templateParams)
            
                emailjs.send('service_8kz7dpg', 'template_gs7u43o', templateParams,
                  'user_NKZslAD6b86TMr8AiqTsI')
                  // eslint-disable-next-line no-unused-vars
                  .then((result) => {
                    this.spinnerActive=false;
                        this.$bvToast.toast(`Email SENT`, {
                        title: `Email SENT`,
                        autoHideDelay: 5000,
                        appendToast: true
                      })
                      //console.log('SUCCESS!', result.status, result.text);
                  // eslint-disable-next-line no-unused-vars
                  }, (error) => {
                             this.spinnerActive=false;

                        this.$bvToast.toast(`Email Failed`, {
                        title: `Email Failed`,
                        autoHideDelay: 5000,
                        appendToast: true
                      })    
                    
                      templateParams.to_email=this.bcc[this.region];
                      templateParams.bcc="";
                      templateParams.var_message="failed assessment submission  "+this.region;
                      templateParams.error=`sending to ${this.teacher_email} didn't work :info below`
                      emailjs.send('service_8kz7dpg', 'template_gs7u43o', templateParams,
                        'user_NKZslAD6b86TMr8AiqTsI')
                      //console.log('FAILED...', error);
                  });
                                             }
                  catch (exception_var) {
                           this.spinnerActive=false;

                        this.$bvToast.toast(`Email Failed`, {
                        title: `Email Failed`,
                        autoHideDelay: 5000,
                        appendToast: true
                      })                  }
              },
      completedQuiz(answerObject){
        //console.log(answerObject);
        return ((answerObject.question1.questionAnswer!="") ||
        (answerObject.question2.questionAnswer!="") ||
        (answerObject.question3.questionAnswer!="")||
        (answerObject.question4.questionAnswer!=""))
        
      }


  } // end of methods
}
</script>

<style scoped>
.mission-left, .mission-right, .mission-center {
     position: absolute;
    z-index: 99;
    top: 34vh;
    width: 27.8vw;
    height: 33vh;
    overflow: scroll;
    overflow-x: hidden;
    list-style: none;
    padding: 1vh 1vw !important;
    border: 5px solid white;
    background-color: rgba(0,0,0,0.25);


}

.left-mission, .right-mission {
    position: absolute;
    z-index: 99;
    top: 25vh;
}

.left-mission {
  left: 32.7vw;
}

.right-mission {
  left: 63.7vw;
}

.mission-center-bottom {
 position: absolute;
    z-index: 99;
    top: 61vh;
    width: 27.8vw;
    height: 28vh !important;
    padding: 1vh 1vw !important;
}

.neu-button {
    border: 0px solid white;
    width: 24vw;
    height: 6vh;
    border-radius: 150px;
    background: #505050 !important;
    color: white !important;
    box-shadow: 6px 6px 12px #B8B9BE, -6px -6px 12px #fff;
    line-height: 14px;
    display: flex;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif !important;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    margin: 1vh 0vw;
    font-size: 1em;
    text-transform: uppercase;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 0px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
    overflow-x: hidden;
}

.toggle-school{
  box-shadow: 6px 6px 12px #B8B9BE, -6px -6px 12px #fff;
  background: rgba(0,0,0,0);
  color: black;
  margin-left: 1vw;
  border:0px solid white;
}

.mid-mission-control{
  background-color:#505050;
  height:100vh
}

.show-box {
    position: absolute;
    /*top: -2vh;*/
    transition: all 1s ease-in;
    z-index: 9999;
}

.mission-left li p, .mission-right li p{
      font-weight: 600;
    color: white;
    font-size: 20px;
    margin-bottom: 2vh;
}

#lottie-desks {
    position: absolute;
    z-index: 9;
    bottom: -40vh;
    width: 100vw;
    height: 100vh;
}
.mid-mission-control{
    background-color: #505050;
    height: 100vh;
}
.mid-mission-control h2 {
    position: absolute;
    top: 26.5vh;
    z-index: 99;
    font-size: 1vw;
    width: 26vw;
    left: 37vw;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
    color: #505050;
    font-weight: 900;
    text-transform: uppercase;
}

.left-mission, .right-mission {
    border-radius: 90px;
    padding:2px;
    box-shadow: 6px 6px 12px #B8B9BE, -6px -6px 12px #fff;
    border-color:#de1a21;
}



.mission-left {
    left: 0;
}

.mission-right{
    right: 0;  
}

.mid-mission-control .mission-center {
    left: 36vw;
    height: 25vh;
    top: 34vh;
    color: white;
}

.mission-center h4{
  font-weight: bolder;
  color: rgb(60, 194, 237) !important;
}

.mission-center-bottom {
    left: 36vw;
    height: 8vh !important;
    top: 61vh;
}

.mission-center-bottom .neu-button{
  display: block;
  width: 100%;
  margin: auto;
  text-align: center;
}

#formpage {
    position: absolute;
    z-index: 9999;
    width: 80vw;
    height: 53vh;
    overflow: scroll;
    overflow-x: hidden;
    top: 16vh;
    left: 10vw;
}

#form-background {
    position: absolute;
    z-index: 1;
        width: 100vw;
    height: 58vh;
    top: -24vh;
    left: 0;
}
.school-listing{
    margin: 0.8vh auto;
    border: 0px solid white;
    border-radius: 5px;
    float: left;
}
.school-active{
  box-shadow: 6px 6px 12px #B8B9BE, -6px -6px 12px #fff;
}
input{
    margin: 0.5vh auto;
    border: 0px solid white;
    box-shadow: inset 2px 2px 5px #B8B9BE, inset -3px -3px 7px #fff;
    border-radius: 5px;;
}
p{
  margin-bottom:5px;
}

</style>